import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';

export const ADDRESS_DETAILS_KEYS = [
    'buildingNumber',
    'propertyNumber',
    'subbuilding',
    'streetName',
    'streetNumber',
    'unitNumber'
];

// map keys from GetPlayerInfo.DataMap to UpdatePlayerInfo.DataMap
export const PLAYER_INFO_DIFFERENCE_MAP = {
    currency: 'currencyCode',
    username: 'userName',
    signupClientPlatform: 'clientPlatform',
    birthDate: 'birthdate',
    bonusGroupId: 'bonusgroupid',
    countryCode: 'countrycode',
    firstName: 'firstname',
    funUsername: 'funusername',
    funPassword: 'funpassword',
    lastName: 'lastname',
    noBonus: 'nobonus',
    vipLevel: 'viplevel',
    wantMail: 'wantmail',
    workPhone: 'workphone',
    bannerId: 'bannerid',
    clientType: 'clienttype',
    profileId: 'profileid',
    refererUrl: 'refererurl',
    remoteIp: 'remoteip'
};

export const DEFAULT_VALUE_FOR_HIDE_FROM_USER_TYPES = [
    FORM_FIELD_TYPE.TEXT,
    FORM_FIELD_TYPE.EMAIL,
    FORM_FIELD_TYPE.DATE_PICKER
];

export const SUPPORTED_FIELD_TYPES = [
    FORM_FIELD_TYPE.TEXT_LABEL,
    FORM_FIELD_TYPE.TEXT,
    FORM_FIELD_TYPE.PASSWORD,
    FORM_FIELD_TYPE.CHECKBOX,
    FORM_FIELD_TYPE.RADIO_BUTTON,
    FORM_FIELD_TYPE.DROPDOWN,
    FORM_FIELD_TYPE.DATE_OF_BIRTH,
    FORM_FIELD_TYPE.DATE_PICKER,
    FORM_FIELD_TYPE.USER_NAME,
    FORM_FIELD_TYPE.EMAIL,
    FORM_FIELD_TYPE.BUTTON,
    FORM_FIELD_TYPE.SPANISH_ID,
    FORM_FIELD_TYPE.CELLPHONE,
    FORM_FIELD_TYPE.PHONE,
    FORM_FIELD_TYPE.COUNTRY,
    FORM_FIELD_TYPE.CURRENCY_CODE,
    FORM_FIELD_TYPE.IBAN
];

export const AREA_CODES = {
    HIDDEN: 'hidden',
    LIST: 'list',
    PREDEFINED: 'predefined'
};

export const INTERNAL_EMAIL = 'test@playtech.com';
